import Api from "../../services/apiListBiomax";

/**
 * Store Biomax: roles y permisos contra /api/biomax (biomaxRoutes en el back).
 * Misma estructura que modSeguridad para que las vistas Biomax lo usen igual.
 */
export default {
  namespaced: true,
  state: {
    roles: [],
    permisos: {},
    errorMsj: "",
  },
  getters: {},
  mutations: {
    setRoles: (state, roles) => {
      state.roles = roles;
    },
    setPermisos: (state, permisos) => {
      state.permisos = permisos;
    },
  },
  actions: {
    actGetRoles: async ({ commit }, params = {}) => {
      let response = await Api.getRoles(params);
      if (response.error) return response.error;
      commit("setRoles", response);
      return true;
    },

    actSaveRoles: async ({ commit }, data) => {
      let response = await Api.saveRoles(data);
      if (response.error) return response.error;
      return true;
    },

    actEditRoles: async ({ commit }, data) => {
      let response = await Api.editRoles(data);
      if (response.error) return response.error;
      return true;
    },

    actDeleteRoles: async ({ commit }, id) => {
      let response = await Api.deleteRoles(id);
      if (response.error) return response.error;
      return true;
    },

    actGetPermisos: async ({ commit }, id) => {
      let response = await Api.getPermisos(id);
      if (response.error) return response.error;
      commit("setPermisos", response);
      return true;
    },

    actSavePermisos: async ({ commit }, data) => {
      let response = await Api.savePermisos(data);
      if (response.error) return response.error;
      return true;
    },
  },
};
